<template>
  <div class="Reportar">
    <button
      @click="reportar"
      type="button"
      class="btn -clear -hasIcon"
      aria-label="Remover informações"
    >
      <icon name="reportar" size="large" class="-left"></icon>
      <span class="label">Remover informações</span>
    </button>
    <form action="/reportar/pagina" ref="form-reportar" method="post">
      <input type="hidden" name="type" v-model="type">
      <input type="hidden" name="objetoId" v-model="objetoId">
      <input type="hidden" name="objetoType" v-model="objetoType">
      <input type="hidden" name="url" v-model="url">
      <input type="hidden" name="pagina" v-model="pagina">
    </form>
    <reportar-modal v-if="showModal" @close="closeModal" @reportar-pagina="irParaPaginaReportar"></reportar-modal>
  </div>
</template>

<script>
import ReportarModal from "./modals/Reportar.vue";
export default {
  props: {
    light: {
      default: false
    },
    url: {
      required: true,
      type: String
    },
    type: {
      required: true,
      type: String
    },
    pagina: {
      required: false,
      default: null,
      type: String
    },
    objetoId: {
      required: true,
      type: String
    },
    objetoType: {
      required: true,
      type: String
    },
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    reportar() {

      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    irParaPaginaReportar() {
      this.$refs['form-reportar'].submit();
    }
  },
  components: {
    ReportarModal
  }
};
</script>

<style lang="stylus"></style>
